export const STORY_COVER_FALLBACKS = [
  '/images/book-covers/alex.png',
  '/images/book-covers/ella.png',
  '/images/book-covers/oliver.png',
  '/images/book-covers/mary.png',
  '/images/book-covers/mina.png',
  '/images/book-covers/alex_space.png'
];

export const DEFAULT_STORY_COVER = STORY_COVER_FALLBACKS[0];

export function getStoryCoverFallback(id) {
  const numericId = Number(id);

  if (!Number.isFinite(numericId) || numericId <= 0) {
    return DEFAULT_STORY_COVER;
  }

  return STORY_COVER_FALLBACKS[(Math.floor(numericId) - 1) % STORY_COVER_FALLBACKS.length];
}

export function applyImageFallback(event, fallbackSrc = DEFAULT_STORY_COVER) {
  const image = event?.currentTarget || event?.target;

  if (!image || image.dataset?.fallbackApplied === 'true') {
    return;
  }

  if (image.dataset) {
    image.dataset.fallbackApplied = 'true';
  }

  image.src = fallbackSrc;
}
